import React, { useState } from "react";
import { useSelector } from "react-redux";

import Logo from "../assets/images/logo.webp";
import Facebook from "../assets/images/icons/social/facebook.svg";
import Instagram from "../assets/images/icons/social/Instagram.svg";
import Whatsapp from "../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../assets/images/icons/social/Telegram.svg";
import Twitter from "../assets/images/icons/social/Twitter.svg";
import BTC from "../assets/images/icons/pay-partners/btc.svg";
import Usdt from "../assets/images/icons/pay-partners/usdt.svg";
import Ethereum from "../assets/images/icons/pay-partners/ethereum.svg";
import PhonePe from "../assets/images/icons/pay-partners/phonepe.svg";
import GPay from "../assets/images/icons/pay-partners/gpay.svg";
import PayTM from "../assets/images/icons/pay-partners/paytm.svg";
import UPI from "../assets/images/icons/pay-partners/upi.svg";
import Age18Plus from "../assets/images/icons/age18-plus.webp";
import LicenseValidation from "../assets/images/license.png";
import AndroidIcon from "../assets/images/icons/android-icon.svg";
import ChevronRight from "../assets/images/icons/chevron-right.svg";
import BottomNav from "./BottomNav";

import Ezugi from "../assets/images/provider/ezugi.webp";
import Evolution from "../assets/images/provider/evolution.webp";
import Supernowa from "../assets/images/provider/supernowa.webp";
import XPG from "../assets/images/provider/xpg.webp";
import Vivo from "../assets/images/provider/vivogaming.webp";
import Slots from "../assets/images/provider/powergames.webp";
import Spribe from "../assets/images/provider/spribe.webp";
import WorldCasino from "../assets/images/provider/worldcasino.webp";
import Qtech from "../assets/images/provider/qtech.webp";
import Netent from "../assets/images/provider/netent.webp";
import Jili from "../assets/images/provider/playngo.webp";
import Kingmaker from "../assets/images/provider/kingmaker.webp";
import RedTiger from "../assets/images/provider/redtiger.webp";

import Rating from "../assets/images/icons/rating1.png";

import BankDeposit from "../assets/images/payments/BankDeposit.png";
import Gpay from "../assets/images/payments/Gpay.png";
import Hdfc from "../assets/images/payments/HDFC.png";
import Icici from "../assets/images/payments/ICICI.png";
import Kotak from "../assets/images/payments/Kotak.png";
import MasterCard from "../assets/images/payments/MasterCard.png";
import Neteller from "../assets/images/payments/Neteller.png";
import Phonepe from "../assets/images/payments/Phonepe.png";
import Sbi from "../assets/images/payments/SBI.png";
import Skrill from "../assets/images/payments/Skrill.png";
import Upi from "../assets/images/payments/UPI.png";
import Visa from "../assets/images/payments/Visa.png";
import Worldpay from "../assets/images/payments/WorldPay.png";

import { useTranslation } from "react-i18next";

const BeforeLoginFooter = () => {
  const { appDetails } = useSelector((state) => state.app);
  const { t } = useTranslation();
  return (
    <>
      <footer className="footer">
        <div className="GameProviderSection">
          <div className="ServiceSection">
            <div className="ExcellentSection">
              <p>EXCELLENT SERVICES</p>
              <img src={Rating} alt="" />
              <p>5.0 / 5.0 - 5891 ratings</p>
              <p></p>
            </div>
          </div>
          <div className="GamesProvider">
            <h3>Game Providers</h3>
            <ul>
              <li>
                <img src={Ezugi} alt="" />
              </li>
              <li>
                <img src={Evolution} alt="" />
              </li>
              <li>
                <img src={Supernowa} alt="" />
              </li>
              <li>
                <img src={XPG} alt="" />
              </li>
              <li>
                <img src={Vivo} alt="" />
              </li>
              <li>
                <img src={Slots} alt="" />
              </li>
              <li>
                <img src={Spribe} alt="" />
              </li>
              <li>
                <img src={WorldCasino} alt="" />
              </li>
              <li>
                <img src={Qtech} alt="" />
              </li>
              <li>
                <img src={Netent} alt="" />
              </li>
              <li>
                <img src={Kingmaker} alt="" />
              </li>
              <li>
                <img src={Jili} alt="" />
              </li>
              <li>
                <img src={RedTiger} alt="" />
              </li>
            </ul>
          </div>
          <div className="PaymentSection">
            <h3>Payments Methods</h3>
            <ul>
              <li>
                <img src={BankDeposit} alt="" />
              </li>
              <li>
                <img src={Gpay} alt="" />
              </li>
              <li>
                <img src={Hdfc} alt="" />
              </li>
              <li>
                <img src={Icici} alt="" />
              </li>
              <li>
                <img src={Kotak} alt="" />
              </li>
              <li>
                <img src={MasterCard} alt="" />
              </li>
              <li>
                <img src={Neteller} alt="" />
              </li>
              <li>
                <img src={Phonepe} alt="" />
              </li>
              <li>
                <img src={Sbi} alt="" />
              </li>
              <li>
                <img src={Skrill} alt="" />
              </li>
              <li>
                <img src={Upi} alt="" />
              </li>
              <li>
                <img src={Visa} alt="" />
              </li>
              <li>
                <img src={Worldpay} alt="" />
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-links">
          <ul>
            <h5>Menu</h5>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/casinogames">Casino</a>
            </li>
            <li>
              <a href="/livecasino">Live Casino</a>
            </li>
            {/* <li>
              <a href="/atlas-lobby">Sports</a>
            </li> */}
            <li>
              <a href="/sports/Cricket">Exchange</a>
            </li>
            <li>
              <a href="/casino/spribe/aviator">Aviator</a>
            </li>
          </ul>
          <ul>
            <h5>Sitemap</h5>
            <li>
              <a href="/responsiblegames">Responsible Gaming</a>
            </li>
            <li>
              <a href="/termss">Terms and Conditions</a>
            </li>
            {/* <li>
              <a href="/beforebonusterms">Bonus Terms and Conditions</a>
            </li>
            <li>
              <a href="/beforewithdrawal-policy">Withdrawal Policy</a>
            </li> */}
            <li>
              <a href="/fairplays">Fair Play</a>
            </li>
            <li>
              <a href="/gamesrules">Games Rules</a>
            </li>
          </ul>
          <ul>
            <h5>Privacy and Policy</h5>
            <li>
              <a href="/privacypolicys">Privacy Policy</a>
            </li>

            {/* <li>
              <a href="/aml_kyc_policys">AML/KYC Policy</a>
            </li> */}
          </ul>
          <ul>
            <h5>Support</h5>
            <li>
              <a href="/contactuss">Contact Us</a>
            </li>
            {/* <li>
              <a href="/aboutuss">About Us</a>
            </li> */}
          </ul>
        </div>

        <div className="social-wallet">
          <div className="logo">
            <a href="/homr">
              <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
              {/* <img src={Logo} alt="Logo" /> */}
            </a>

            {/* <p>{appDetails?.FOOTER_TEXT || ""}</p> */}
          </div>
          <div className="license-apk">
            {/* <a href="javascript:void(0)" className="license">
              <img src={LicenseValidation} alt="license validation" />
            </a> */}

            <a
              href="javascript:void(0)"
              download=""
              className="download-apk ms-0"
            >
              <img src={AndroidIcon} alt="android apk" />
              <div className="text">
                <span>Application</span>
                <strong>for Android</strong>
              </div>
              <img
                src={ChevronRight}
                alt="chevron right"
                className="arrow ms-auto d-lg-none"
              />
            </a>
          </div>
          <div className="follow-us">
            <h5>Follow us</h5>
            <ul>
              <li>
                <a
                  href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Facebook} alt="facebook" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.INSTATGRAM != "" ? appDetails?.INSTATGRAM : "#"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} alt="instagram" />
                </a>
              </li>
              <li>
                <a href="https://x.com/kuberbook247" target="_blank">
                  <img src={Twitter} alt="twitter" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Whatsapp} alt="whatsapp" />
                </a>
              </li>
              <li>
                <a
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} alt="telegram" />
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="sup-wallet">
            <h5>Supported Wallet</h5>
            <ul>
              <li>
                <img src={BTC} alt="ttc" />
              </li>
              <li>
                <img src={Ethereum} alt="ethereum" />
              </li>
              <li>
                <img src={Usdt} alt="usdt" />
              </li>
            </ul>
          </div> */}
        </div>

        {/* <p className="LicenceSection">
          The above Casino or Sportsbook is licensed and authorized by the
          Government of Curacao and operates under the Master License of Gaming
          Services Provider, N.V. #396/JAZ GLH-OCCHKTW0903072526
        </p> */}

        <div className="copy-age">
          <div className="age18">
            <p>
              You can play only if you are an adult. Gambling can cause
              pathological addiction
            </p>
            <img src={Age18Plus} alt="age 18 plus" />
          </div>

          <div className="copyright">
            <p>Copyright © 2025 kuberbook247, All rights reserved.</p>
          </div>
        </div>
      </footer>

      <BottomNav />
    </>
  );
};

export default BeforeLoginFooter;
